export enum TaskMessageType {
    FIRST                   = 1,
    MESSAGE                 = 2,
    NO_REPLY                = 3,

    STATUS_UPDATE_REQUEST   = 4,

    REASSIGN                = 10,// manual reassing

    PRIORITY                = 11,
    SET_DEADLINE            = 12,
    CHANGE_DEADLINE         = 13,
    REMOVE_DEADLINE         = 14,
    ESTIMATE                = 15,
    MOVE                    = 16,
    AUTO_REASSIGN           = 17,// auto reassign

    TIME_REPORT             = 18,
    AR_CHANGE               = 19,  // Experimental ???

    SCHEDULE_DATE           = 20,
    SCHEDULE_SOMEDAY        = 21,
    START_END               = 22,

    VIEW                    = 30,
    ADD_USER                = 31,
    DESCRIPTION_CHANGE      = 32,
}

export enum TaskMessageCommunicationFlow {
    FIRST       = 1,    // First - first message in a flow task A .... or reopen (new block)
    COMMENT     = 2,    // Comment - some one comments (without changing AR user) A-(comment)->B
    GET_BACK    = 3,    // Get Back - ar change to previous user i.e. A->B->A
    SWITCH      = 4,    // Switch  - ar change to other user i.e. A->B->C
    INTERRUPT   = 5,    // Interrupt - ar changed by not ar user i.e. A->B C->A
    NO_REPLY    = 6,    // No reply - ar was changed and original ar user had no chance to reply A->B-(no reply)-C->A (always comes with interrupt)
}